module.exports = __webpack_public_path__ + "19261b81b439861577b3cd715e2f2291.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/navbar/cashier_redisign.png
// module id = 470
// module chunks = 0